import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "html-editable-renderer",
    templateUrl: "./html-editable-renderer.component.html",
    styleUrls: ["./html-editable-renderer.component.scss"]
})
export class HtmlEditableRendererComponent {
    protected htmlCodeEdition: string = null;
    protected cssStylesEdition: string = null;
    protected editDialogVisible: boolean = false;

    // HTML code corresponding to this item.
    @Input() htmlCode: string;

    // Emits HTML code changes when saving.
    @Output() readonly htmlCodeChange: EventEmitter<string> = new EventEmitter();

    // CSS styles corresponding to this item.
    @Input() cssStyles: string;

    // Emits CSS styles changes when saving.
    @Output() readonly cssStylesChange: EventEmitter<string> = new EventEmitter();

    // Hint to show in edition button.
    @Input() editionButtonHint: string;

    // Header to show in edition dialog.
    @Input() editionDialogHeader: string;

    // Class to apply to the inner html renderer.
    @Input() containerClass: string;

    // Header for edition dialog.
    protected get editDialogHeader(): string {
        return !!this.editionDialogHeader?.length
            ? this.editionDialogHeader
            : "Edit layout item";
    }

    // Dialog methods.
    protected showEditDialog(): void {
        this.htmlCodeEdition = this.htmlCode;
        this.cssStylesEdition = this.cssStyles;
        this.editDialogVisible = true;
    }

    protected saveHtmlCodeChanges(): void {
        this.htmlCode = this.htmlCodeEdition;
        this.htmlCodeChange.emit(this.htmlCode);

        this.cssStyles = this.cssStylesEdition;
        this.cssStylesChange.emit(this.cssStyles);

        this.closeEditDialog();
    }

    protected cancelHtmlCodeChanges(): void {
        this.closeEditDialog();
    }

    private closeEditDialog(): void {
        this.htmlCodeEdition = null;
        this.cssStylesEdition = null;
        this.editDialogVisible = false;
    }
}